import styled from 'styled-components'
import { Layout } from 'antd'

const { Content } = Layout

export const LoadingContainer = styled.div`
  height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const AppLayout = styled(Layout)`
  min-height: 100dvh;
  background: var(--color-bg-primary);
  transition: background-color 0.2s ease;
`

export const AppContent = styled(Content)`
  margin-top: 64px;
  min-height: calc(100dvh - 64px);
  background: var(--color-bg-primary);
  transition: background-color 0.2s ease;
`
